export default __webpack_public_path__ + "static/media/flowImage.b090f9e4.svg";